import { Component, DestroyRef, inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { NewsFeedService } from '@fi-app/news-feed/news-feed.service';
import { StatisticService } from '@fi-app/shared/statistic/statistic.service';
import { SystemNotificationsService } from '@fi-app/system-notifications/system-notifications.service';
import { FiInactivityCountdownNotificationService } from '@fi-app/utilities/inactivity-countdown-notification/inactivity-countdown-notification.service';
import { FiUserSharedService } from '@fi-shared/fi-user-shared/fi-user-shared.service';
import { FiAuthChangeLoginService } from '@fi-shared/fi-auth-shared/fi-auth-change-login.service';
import { FiUserHelperService } from '@fi-shared/fi-user-shared/fi-user-helper.service';
import { FiOnboardingActiveDataService } from '@fi-app/fi-onboarding/fi-onboarding-active/fi-onboarding-active-data.service';
import { FiLikesStoreService } from '@fi-shared/fi-likes/services/fi-likes-store.service';

@Component({
    selector: 'fi-app-init',
    template: '',
    standalone: false,
})
export class FiAppInitComponent implements OnInit, OnDestroy {
    constructor(
        private ngZone: NgZone,
        private newsFeedService: NewsFeedService,
        private statisticService: StatisticService,
        private fiSystemNotificationsService: SystemNotificationsService,
        private inactivityCountdownService: FiInactivityCountdownNotificationService,
        private fiUserSharedService: FiUserSharedService,
        private fiUserHelperService: FiUserHelperService,
        private fiAuthChangeLoginService: FiAuthChangeLoginService,
        private fiOnboardingActiveDataService: FiOnboardingActiveDataService,
        private fiLikesStoreService: FiLikesStoreService,
    ) {}

    private destroyRef = inject(DestroyRef);

    ngOnInit(): void {
        this.ngZone.runOutsideAngular(() => {
            this.newsFeedService.Initialize();
            this.statisticService.InitStatistics();
            this.fiSystemNotificationsService.init();
            this.fiUserSharedService.init();
            this.fiUserHelperService.init();
            this.fiAuthChangeLoginService.init();
        });

        this.fiOnboardingActiveDataService.init(this.destroyRef);
        this.fiLikesStoreService.init(this.destroyRef);

        this.inactivityCountdownService.ResetTimer();
        this.inactivityCountdownService.Reset = () => {
            this.inactivityCountdownService.ResetTimer();
        };
    }

    ngOnDestroy() {
        this.statisticService.stopStatisticsGathering();
    }
}
